/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Title_1_PostInputs */

const tr_landing_intro_title_1_post = /** @type {(inputs: Landing_Intro_Title_1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`talep ediyor.`)
};

const en_landing_intro_title_1_post = /** @type {(inputs: Landing_Intro_Title_1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a year.`)
};

const de_landing_intro_title_1_post = /** @type {(inputs: Landing_Intro_Title_1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Jahr.`)
};

const ru_landing_intro_title_1_post = /** @type {(inputs: Landing_Intro_Title_1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в год.`)
};

/**
* | output |
* | --- |
* | "a year." |
*
* @param {Landing_Intro_Title_1_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_title_1_post = /** @type {((inputs?: Landing_Intro_Title_1_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Title_1_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_title_1_post(inputs)
	if (locale === "de") return de_landing_intro_title_1_post(inputs)
	if (locale === "ru") return ru_landing_intro_title_1_post(inputs)
	return tr_landing_intro_title_1_post(inputs)
});